(function() {
    var forEach = Array.prototype.forEach;

    // Disable context menu on images
    forEach.call(document.querySelectorAll('.site-content img'), function(image) {
        image.addEventListener('contextmenu', function(e) {
            if (e.preventDefault) e.preventDefault();
            return false;
        });
    });

    // Fill in location and referrer hidden fields for the subscription form
    function fillInput(inputClass, value) {
        forEach.call(document.querySelectorAll('input.'+inputClass), function (el) {
            el.value = el.value || value;
        });
    };
    fillInput('location', window.location.href);
    fillInput('referrer', document.referrer);
})();
